// ** Logo
import logo from "../../assets/images/Qase-Loading-Animation-v1.gif";

const FallbackSpinner = () => {
	return (
		<div className="fallback-spinner app-loader">
			<img className="fallback-logo" src={logo} alt="logo" />
			<div className="loading">
				<div className="effect-1 effects"></div>
				<div className="effect-2 effects"></div>
				<div className="effect-3 effects"></div>
			</div>
		</div>
	);
};

export default FallbackSpinner;
